import { FC } from "react";
// import { questions, QuizData } from "../../pages/Quiz/Quiz";
import './ViewPage.scss';
import { Checkbox } from "@mui/material";
import images from "../../assets/images";
import { useAppSelector } from "../../redux/app/hooks";
import { STUDENT_ROLE, TEACHER_ROLE } from "../../utils/constants";
import { useLocation, useNavigate } from "react-router-dom";

type Options = {
    option_A: string;
    option_B: string;
    option_C?: string;
    option_D?: string;
    option_E?: string;
    option_F?: string;
  }
  
  export type questions = {
    qs_id: string;
    qs_info: string;
    question_id?:string;
    is_correct: string;
    options: Options;
    question: string;
    isCorrectAnswer: boolean;
    chosen_option: string;
  }
  
  export type Students = {
    studentAvatarUrl: string;
    studentId: string;
    studentName: string;
    totalScore: number;
  }

export type QuizData = {
    quizId: string;
    isClassroom: boolean;
    createdAt: string;
    quizTitle: string;
    updatedAt: string;
    questions: questions[];
    status: string;
    totalScore: number;
    totalQuestions: number;
    totalCompletedStudents?: number;
    students: Students[];
    questionsCount: number;
    results: any[];
    feedId : string
  }

type InputProps = {
    data: QuizData | undefined;
    isQuestionBank?: boolean;
};

const ViewPage:FC<InputProps> = ({ data, isQuestionBank}) => {

    const { Checkbox_outline, Checkbox_checked_green, Checkbox_checked_wrong } = images;
    const role = useAppSelector((state) => state.auth.role);
    const navigate = useNavigate();
    const { state } = useLocation();

    const handleRetry = () => {
        const setState = { ...state, isRetry: true }
        navigate('/student-classroom/question-bank/test', { 
            state: setState
        });
    }
    
    return (
        <div className="ViewPageInnerContainer">
            <div className="QuestionContainer">
                {data?.questions?.map((value: questions, index: number) => { 
                    return (
                        <div className="QuestionInnerContainer">
                            <div className="Question">
                            {`${ index + 1 }. ${ isQuestionBank ? value?.question : value?.qs_info }`}
                            </div>
                            <div className={`OptionsContainer`}>
                            {Object.values(value.options)?.map((item: any, index: number) => {
                                return (
                                    <div className="Options">
                                        <div className="OptionCode">{`${String.fromCharCode(65 + index)}.`}</div>
                                        <div className="OptionText">{ item } </div>
                                        <div className="CheckboxContainer">
                                            <Checkbox
                                                icon={<img src={Checkbox_outline} alt="checkboxIcon"/>}
                                                checkedIcon={<img alt="checkboxGreen" src={role === TEACHER_ROLE ? Checkbox_checked_green : ( value?.isCorrectAnswer ? Checkbox_checked_green : (index === (value?.is_correct?.charCodeAt(0) - 65) ? Checkbox_checked_green : Checkbox_checked_wrong) )} />}
                                                checked={ role === TEACHER_ROLE ? index === (value?.is_correct?.charCodeAt(0) - 65) : (index === (value?.chosen_option?.charCodeAt(0) - 65) || (!isQuestionBank && index === (value?.is_correct?.charCodeAt(0) - 65))) || (isQuestionBank && index === (value?.is_correct?.charCodeAt(0) - 65)) }
                                                // checked={true}
                                                disabled
                                            />
                                        </div>
                                    </div>
                                )})}
                            </div>
                        </div>
                    )
                })}
                {(role === STUDENT_ROLE) && (
                    <>
                        <div className="scoreContainer">
                            Your Score: <span className="score">
                                {`${data?.totalScore === 0 ? '0' : String(data?.totalScore).padStart(2, '0')}/${String(data?.totalQuestions).padStart(2, '0')}`}
                            </span>                    
                        </div>
                        {(isQuestionBank) && (
                            <div className="ButtonContainer">
                                <button className='NextButton' onClick={() => {handleRetry()}}>{"Retry"}</button>
                            </div>
                        )}
                    </>
                )}
            </div>
        </div>
    );
}

export default ViewPage;